import {securedFetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import {API_URL} from '../constants';
import * as Sentry from '@sentry/react';

export const updatePrePackagedDetails = (details: $TSFixMe) => {
  details.forEach((detail: $TSFixMe) => {
    securedFetchRequest(`${API_URL}/rfps/detail/${detail.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({value: detail.value}),
    })
      .then(() => {})
      .catch((err) => {
        process.env.NODE_ENV === 'development' && console.error(err);
        Sentry.withScope(function (scope) {
          scope.setTag(
            'section',
            'UpdateTemplateDetails.tsx updatePrePackagedDetails()',
          );
          Sentry.captureException(err);
        });
      });
  });
};
